<div id="mediaTypeNav">
    <div class="anchors">
        <a
            class="anchor"
            *ngFor="let anchor of availableAnchors; let i = index"
            id="selenium-{{ anchor.title.replace(' ', '-').toLowerCase() }}-browse-anchor"
            [ngClass]="{
                active: selectedItem === anchor.id || (i === 0 && !selectedItem)
            }"
            (click)="onClick(anchor.id)"
        >
            {{ anchor.title | pluralizeMediaType }}
        </a>
    </div>
</div>
